import { AppDispatch } from '@/store/index';
import { MainLayoutSlice } from '@/store/reducers/MainLayoutReducer';

export const MainLayoutActionCreators = {
    toggleMenu: (flag: boolean) => async (dispatch: AppDispatch) => {
        dispatch(MainLayoutSlice.actions.toggleMenu(flag));
    },
};
